/* filepath: d:\cyber-news-ai\frontend\src\components\ThemeToggle.tsx */
import React from 'react';
import { useTheme } from '../contexts/ThemeContext'; // Confirmed correct path
import './ThemeToggle.css';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      className={`theme-toggle ${theme}`}
      onClick={toggleTheme}
      title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
    >
      <div className="toggle-wrapper">
        <div className="toggle-icon">
          {theme === 'dark' ? '☀️' : '🌙'}
        </div>
        <span className="toggle-text">
          {theme === 'dark' ? 'Light Mode' : 'Dark Mode'}
        </span>
      </div>
    </button>
  );
};